export enum SupplierTableEntityType {
  Address = 'Address',
  BusinessName = 'BusinessName',
  ContactsName = 'ContactsName',
  DeliveryMethod = 'DeliveryMethod',
  Email = 'Email',
  Phone = 'Phone'
}
